// Mock data for R S T & Co. Chartered Accountants

export const companyInfo = {
  name: "R S T & Co.",
  tagline: "Chartered Accountants",
  email: "info@rstandco.co.in",
  phone: "+91-9964666007",
  address: "#222, 1st & 2nd Floor, 80 Ft. Service Main Road, 12th Block BDA Layout, Marilingappa Extension, Nagarabhavi, Bengaluru, Karnataka – 560072",
  mapsUrl: "https://maps.app.goo.gl/AYAMY2bM1A49UYzx8",
};

export const heroContent = {
  headline: "Empowering Businesses with Expert Financial Solutions",
  subheadline: "Your trusted partner for accounting, consulting, and compliance—designed for startups, established businesses, and foreign companies entering India.",
  ctaText: "Schedule a Consultation",
  trustBadges: [
    "1500+ Clients Served",
    "15+ Years Experience",
    "Startup India Expertise",
    "100% Satisfaction"
  ]
};

export const quickActions = [
  {
    id: 1,
    title: "Starting a Startup in India?",
    description: "Complete incorporation, registration, and Startup India certification assistance.",
    icon: "Rocket",
    link: "#cta"
  },
  {
    id: 2,
    title: "Foreign Company Entering India?",
    description: "End-to-end support for subsidiary setup, compliance, and regulatory filings.",
    icon: "Globe",
    link: "#cta"
  },
  {
    id: 3,
    title: "NRI Property Tax Issues?",
    description: "Expert guidance on capital gains, TDS, and tax optimization for NRIs.",
    icon: "Home",
    link: "#cta"
  },
  {
    id: 4,
    title: "GST Compliance Challenges?",
    description: "Comprehensive GST registration, filing, audits, and consultation services.",
    icon: "FileCheck",
    link: "#cta"
  }
];

export const services = [
  {
    id: 1,
    icon: "Cpu",
    title: "AI/ML Compliance & Audit",
    description: "Navigate the evolving AI regulatory landscape with expert compliance advisory, risk assessment, and data privacy consulting for AI-driven businesses.",
    features: [
      "AI/ML regulatory compliance advisory",
      "AI system audits & risk assessment",
      "Data privacy & AI ethics consulting",
      "Algorithm transparency & fairness reviews"
    ],
    featured: true,
    size: "large"
  },
  {
    id: 2,
    icon: "Globe2",
    title: "NRI Taxation & Investment",
    description: "End-to-end tax, FEMA, and wealth solutions for NRIs — including Visa-grade net-worth certificates, DTAA, property transactions, and repatriation.",
    features: [
      "Net Worth Certificates for Visa purposes",
      "Financial Statements for Visa applications",
      "DTAA & Foreign Tax Credit consulting",
      "Property transaction & capital-gains advisory",
      "Repatriation consulting & FEMA compliance",
      "NRI income tax returns & TDS compliance"
    ],
    featured: true,
    size: "large"
  },
  {
    id: 3,
    icon: "Brain",
    title: "Strategic Consulting",
    description: "Expert financial and business consulting to help you make informed decisions, optimize operations, and drive sustainable growth.",
    features: [
      "Business planning & strategy",
      "Financial restructuring",
      "Risk management advisory",
      "Growth optimization"
    ],
    size: "medium"
  },
  {
    id: 4,
    icon: "Workflow",
    title: "Accounting & Outsourcing",
    description: "Comprehensive accounting and bookkeeping services that keep your finances accurate, compliant, and ready for strategic decision-making.",
    features: [
      "Complete bookkeeping services",
      "Financial statement preparation",
      "Payroll management",
      "Monthly financial reporting"
    ],
    size: "medium"
  },
  {
    id: 5,
    icon: "FileText",
    title: "Tax & Compliance",
    description: "Navigate complex tax regulations with confidence. We handle all direct and indirect tax compliances so you can focus on your business.",
    features: [
      "GST filing & compliance",
      "Income tax planning",
      "TDS management",
      "Tax optimization strategies"
    ],
    size: "medium"
  },
  {
    id: 6,
    icon: "Scale",
    title: "Audit & Assurance (incl. ESG & IPO Readiness)",
    description: "Statutory, tax, internal, ESG and IPO Readiness Audits conducted with precision to ensure compliance, sustainability disclosures, and listing readiness.",
    features: [
      "Statutory & Tax Audit",
      "ESG Audit & Sustainability Assurance",
      "IPO Readiness Audit & Diligence",
      "Internal, Concurrent & Bank Audits"
    ],
    size: "medium"
  },
  {
    id: 7,
    icon: "Building",
    title: "Foreign Subsidiary & Company Setup",
    description: "End-to-end formation and ongoing compliance management for Foreign Subsidiaries, MNC entities, JVs and technical collaborations in India.",
    features: [
      "Foreign Subsidiary Formation & Maintenance",
      "Technical Collaboration Coordination",
      "Comprehensive Compliance for Foreign Subs",
      "Private Ltd · LLP · OPC · Branch / LO"
    ],
    size: "medium"
  },
  {
    id: 8,
    icon: "TrendingUp",
    title: "Transfer Pricing",
    description: "Expert transfer pricing studies, documentation, and representation for international transactions and related party dealings.",
    features: [
      "Transfer pricing study",
      "Documentation & reports",
      "Compliance representation",
      "International taxation"
    ],
    size: "medium"
  },
  {
    id: 9,
    icon: "FileBarChart",
    title: "Reports & Funding",
    description: "Professional reports for loans, investments, and business valuations to support your funding requirements.",
    features: [
      "CMA data for bank loans",
      "Project reports",
      "Business valuation",
      "Due diligence reports"
    ],
    size: "medium"
  }
];

export const latestNews = [
  {
    id: 1,
    title: "Union Budget 2026: Key Tax Proposals",
    date: "15 Dec 2025",
    category: "Tax Updates",
    excerpt: "Important income tax changes affecting taxpayers - reduced TCS rates, extended return filing dates, and penalty revisions.",
    link: "#"
  },
  {
    id: 2,
    title: "GST Compliance Alert: New Filing Requirements",
    date: "10 Dec 2025",
    category: "GST",
    excerpt: "Updated GST return filing procedures and deadlines for FY 2025-26. Mandatory e-invoicing threshold reduced.",
    link: "#"
  },
  {
    id: 3,
    title: "Startup India: New Benefits for Early-Stage Companies",
    date: "5 Dec 2025",
    category: "Startup",
    excerpt: "Enhanced tax benefits and compliance relaxations announced for DPIIT-recognized startups.",
    link: "#"
  },
  {
    id: 4,
    title: "Foreign Investment Guidelines Updated",
    date: "1 Dec 2025",
    category: "FDI",
    excerpt: "RBI releases new guidelines for foreign direct investment and overseas investment reporting.",
    link: "#"
  }
];

export const specializations = [
  {
    id: 1,
    icon: "Rocket",
    title: "Startup India Specialists",
    description: "End-to-end support for startups—from incorporation to funding compliance, we understand your unique challenges.",
    benefits: [
      "DPIIT recognition assistance",
      "Compliance for funding rounds",
      "Startup-friendly pricing",
      "Scalable solutions"
    ]
  },
  {
    id: 2,
    icon: "Globe",
    title: "Foreign Company Setup",
    description: "Seamless entry into the Indian market with expert guidance on regulations, compliance, and operational setup.",
    benefits: [
      "Company registration in India",
      "Regulatory compliance",
      "Cross-border tax planning",
      "Ongoing support"
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Shield",
    title: "100% Satisfaction",
    description: "Impeccable track record with complete client satisfaction across all engagements."
  },
  {
    id: 2,
    icon: "Zap",
    title: "Tech-Driven",
    description: "Modern cloud-based systems for real-time access to your financial data, anytime, anywhere."
  },
  {
    id: 3,
    icon: "Users",
    title: "Personalized Service",
    description: "Dedicated account manager who understands your business and provides tailored solutions."
  },
  {
    id: 4,
    icon: "Award",
    title: "15+ Years Expertise",
    description: "Deep industry knowledge across startups, SMEs, and multinational corporations."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Chief Executive Officer",
    company: "O'Reilly Concretes & Asia Civil Designs",
    role: "CEO",
    content: "R S T & Co. has been a steady, trusted partner through every phase of our growth. Their depth in assurance and tax — combined with a founder-friendly approach — has helped us structure our businesses with clarity and confidence.",
    rating: 5
  },
  {
    id: 2,
    name: "Raviraj Hegde",
    company: "Starlink Media OPC",
    role: "CEO",
    content: "As a solo-founded media company, we needed a CA firm that could think like a partner, not just a compliance vendor. The RST & Co. team delivered on both — compliance is airtight, and their advisory has actively shaped our commercial decisions.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. S. Iyer",
    company: "LISA Apparels Pvt. Ltd.",
    role: "Managing Director",
    content: "Across audit, indirect tax, and advisory, the RST & Co. team has been meticulous, responsive, and genuinely invested in our business. They have become an extension of our finance function.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Ramesh",
    company: "Idea Infinity IT Solutions Pvt. Ltd.",
    role: "Managing Director",
    content: "From incorporation through to scaling, RST & Co. has handled our finance, tax, and regulatory work with real ownership. Their guidance has been pragmatic, timely, and commercially aware — exactly what a growing IT business needs.",
    rating: 5
  }
];

export const ctaContent = {
  headline: "Ready to Transform Your Financial Operations?",
  subheadline: "Schedule a free consultation with our experts and discover how we can help your business thrive.",
  primaryCta: "Book Your Consultation",
  secondaryCta: "Call +91-9964666007"
};

export const stats = [
  { label: "Clients Served", value: "1500+", icon: "Users" },
  { label: "Years of Excellence", value: "15+", icon: "Award" },
  { label: "Satisfaction Rate", value: "100%", icon: "CheckCircle" },
  { label: "Startup India Projects", value: "200+", icon: "Rocket" }
];

export const serviceCategories = {
  startBusiness: [
    { name: "Private Limited Company", link: "#cta" },
    { name: "Limited Liability Partnership (LLP)", link: "#cta" },
    { name: "One Person Company (OPC)", link: "#cta" },
    { name: "Partnership Firms", link: "#cta" },
    { name: "Foreign Subsidiary", link: "#cta" },
    { name: "Branch/Liaison Office", link: "#cta" }
  ],
  compliance: [
    { name: "Income Tax Returns", link: "#cta" },
    { name: "GST Filing & Compliance", link: "#cta" },
    { name: "TDS Returns", link: "#cta" },
    { name: "Statutory Audits", link: "#cta" },
    { name: "Tax Audits", link: "#cta" },
    { name: "Annual ROC Filings", link: "#cta" }
  ],
  registrations: [
    { name: "GST Registration", link: "#cta" },
    { name: "PAN & TAN", link: "#cta" },
    { name: "MSME Registration", link: "#cta" },
    { name: "Shop Act Registration", link: "#cta" },
    { name: "PF & ESI Registration", link: "#cta" },
    { name: "Import Export Code (IEC)", link: "#cta" }
  ],
  specialized: [
    { name: "AI/ML Compliance Audit India", link: "#cta" },
    { name: "NRI Tax Consultant Bangalore", link: "#cta" },
    { name: "NRI Property Taxation Services", link: "#cta" },
    { name: "FEMA Compliance Advisory", link: "#cta" },
    { name: "AI Data Privacy Consulting", link: "#cta" },
    { name: "Transfer Pricing", link: "#cta" },
    { name: "Foreign Direct Investment", link: "#cta" },
    { name: "Business Valuation", link: "#cta" },
    { name: "NRI Investment Advisory", link: "#cta" },
    { name: "Due Diligence", link: "#cta" }
  ]
};

export const seoKeywords = [
  "AI compliance audit India",
  "NRI tax consultant Bangalore",
  "chartered accountant for startups",
  "AI ML regulatory compliance",
  "NRI taxation services India",
  "FEMA compliance advisory",
  "startup CA services Bangalore",
  "AI data privacy consulting",
  "NRI property tax advisory",
  "tech startup accounting services"
];
